





<div class="chart-container">
    
    <mat-card>
    

      <div class="chart-width">

      <canvas id="chartJaehrlicheGebeudeKosten"></canvas>
      </div>
    </mat-card>
  </div>
  